import { IEvent } from "@lib/store/src/calendar";
import styles from "../styles.css";
import { getOptionTemplateByType } from "../modal.templates";
import { createTimePickerSelect } from "../modal.helpers";
import i18next from "i18next";

const getFilterTemplate = () => `
    <div class="filter-container"> 
        <div class="filter-dropdown" id="filter-dropdown">
            <div class="filter-option">
                <label>
                    <input type="checkbox" name="0"> ${i18next.t($ => $.scheduleBacnet.date)}
                </label>
            </div>
            <div class="filter-option">
                <label>
                    <input type="checkbox" name="1"> ${i18next.t($ => $.scheduleBacnet.range)}
                </label>
            </div>
            <div class="filter-option">
                <label>
                    <input type="checkbox" name="2"> ${i18next.t($ => $.scheduleBacnet.weekAndDay)}
                </label>
            </div>
        </div>
    </div>
`

//TODO: Ссылка календаря
// <div class="filter-option">
//     <label>
//         <input type="checkbox" name="3"> Ссылка календаря
//     </label>
// </div>

export const getEditExceptionTemplate = () => `
   <style>
        ${styles}
    </style>
    <div class="modal-week-container">
        <div class="input-container" slot="children">

            <div class="form-row"> 
                <div class="form-block">    
                    <div class="justify-between">
                        <p>${i18next.t($ => $.scheduleBacnet.exception)}</p> 
                        <span class="filter-icon" id="filter-button"></span>
                    </div>
                    
                    ${getFilterTemplate()}
                    
                    <select
                        id="select-event-period"
                        placeholder="${i18next.t($ => $.scheduleBacnet.choosePeriod)}"
                        value="date"
                    >
                    </select>

                    <div>    
                        <p>${i18next.t($ => $.scheduleBacnet.exceptionFieldPriority)}</p>
                        <fw-input type="number" min="1" max="16" value="1" id="priority"></fw-input>
                    </div>  
                </div>  
            </div>
 
            <div class="form-row form-title justify-between">
                <p>${i18next.t($ => $.scheduleBacnet.event)}</p>
                <fw-button id="add-event" color="secondary">${i18next.t($ => $.scheduleBacnet.add)}</fw-button>
            </div> 

            <div class="grid-container">
                <div class="grid-header">
                    <div>${i18next.t($ => $.scheduleBacnet.time)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.dataType)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.value)}</div>
                    <div></div> <!-- Пустой элемент для крестика удаления -->
                </div>
                <div class="grid-body" id="events">
                    
                </div>
            </div>  

            <div class="form-row">
                <div class="form-block">    
                    <p>${i18next.t($ => $.scheduleBacnet.period)}</p>
                    <select
                        id="select-period"
                        placeholder="${i18next.t($ => $.scheduleBacnet.choosePeriod)}"
                        value="date"
                    >
                    </select>  

                    <div id="period-form"></div>
                </div>          
            </div>
        </div>
        
        <div class="modal-buttons-wrap">
            <fw-tooltip id="tooltip" placement="bottom" trigger="hover" content="">
                <fw-button id="submit" color="primary">${i18next.t($ => $.apply)}</fw-button>
            </fw-tooltip>
            <fw-button id="delete" color="primary">${i18next.t($ => $.delete)}</fw-button>
            <fw-button id="reset" color="secondary">${i18next.t($ => $.cancel)}</fw-button>
        </div>
    </div>
`;

export const getEditTemplate = (event: IEvent) => `
    ${createTimePickerSelect(
      `${event?.time?.hours}:${event?.time?.minutes}:${event?.time?.seconds || "00"}`
    )}
    <select
        id="select-type"
        placeholder="${i18next.t($ => $.scheduleBacnet.chooseDataType)}"
        value="${event?.dataType}"
    >
    </select>
    <div id="block-value">
        ${getOptionTemplateByType(event?.dataType, event?.value)}
    </div>
    <div class="delete-btn">✕</div>
`;
